import { ApiScopeBuilder } from '@common/ApiProvider';

export const apiScopeBuilder: ApiScopeBuilder = (apiClientId, permission) =>
  `api://${apiClientId}/${permission}`;
